import type { Authorization } from '@skop-app/lib-domain/types'

import type { PermissionDomainKey, PermissionOperation } from './policy'

const DOMAIN_TO_AUTH_KEY = {
  definitions: 'definitionsAuth',
  properties: 'propertiesAuth',
  references: 'referencesAuth',
  options: 'optionsAuth',
  products: 'productsAuth',
  projects: 'projectsAuth',
  orders: 'ordersAuth',
  settings: 'settingsAuth',
  team: 'teamAuth',
} as const satisfies Record<PermissionDomainKey, keyof Authorization>

export const canMutateDomain = (
  authorization: Authorization | undefined,
  domain: PermissionDomainKey,
  operation: PermissionOperation,
) => Boolean(authorization?.[DOMAIN_TO_AUTH_KEY[domain]]?.[operation])

export const canManageTeamMembers = (
  authorization: Authorization | undefined,
) => Boolean(authorization?.canInviteTeamMember)

export const canManageOrganizationSettings = (
  authorization: Authorization | undefined,
) => Boolean(authorization?.settingsAuth?.canUpdate)

export const canEditTeamAuthorizationPolicy = (
  authorization: Authorization | undefined,
) =>
  Boolean(
    authorization?.user?.isMaster || authorization?.user?.role === 'ADMIN',
  )

export const canManageProjectMembers = (
  authorization: Authorization | undefined,
  projectPermissions?: {
    canManageMembers?: boolean
  } | null,
) =>
  Boolean(authorization?.canInviteTeamMember) &&
  Boolean(projectPermissions?.canManageMembers)

export const canCreateTeams = (authorization: Authorization | undefined) =>
  canMutateDomain(authorization, 'team', 'canCreate')

export const isGuestAuthorization = (
  authorization: Authorization | undefined,
) => authorization?.user?.role === 'GUEST'
